import { render, staticRenderFns } from "./DashboardMediaCallsList.vue?vue&type=template&id=4c7951cc&"
import script from "./DashboardMediaCallsList.vue?vue&type=script&lang=js&"
export * from "./DashboardMediaCallsList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMediaCallsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7951cc')) {
      api.createRecord('4c7951cc', component.options)
    } else {
      api.reload('4c7951cc', component.options)
    }
    module.hot.accept("./DashboardMediaCallsList.vue?vue&type=template&id=4c7951cc&", function () {
      api.rerender('4c7951cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/dashboard/DashboardMediaCallsList.vue"
export default component.exports